const updateForme = () => {
  const $element = document.querySelector(
    "[theme-product-forme]"
  ) as HTMLElement;
  // get search params with key "forme"
  const url = new URLSearchParams(window.location.search);
  let forme = url.get("forme")?.toLowerCase().replace(/ /g, "-");
  if (!$element) {
    return;
  }
  if (!forme) {
    forme = "cœur";
  }

  // update images

  const $imgs = $element.querySelectorAll(
    `.composite-forme-image__img.forme__${forme}`
  );
  $imgs.forEach(($img) => {
    $img.classList.remove("is-hidden");
  });

  // update line item property

  const $btn = $element.querySelector<HTMLElement>(".regular-atc-btn");
  if ($btn) {
    $btn.dataset.property = `Forme/${forme.toUpperCase()}`;
  }

  // update label
  const $label = $element.querySelector<HTMLElement>(".forme-label");
  if ($label) {
    $label.innerHTML = forme.toUpperCase();
  }

  // linked products

  const $linkedProducts =
    $element.querySelectorAll<HTMLElement>(`.linked-product`);
  $linkedProducts.forEach(($item) => {
    const url = $item.dataset.url;
    if (url) {
      $item.addEventListener("click", () => {
        window.location.href = `${url}?forme=${forme}`;
      });
    }
  });

  // active forme swatch

  const $formeSwatches = $element.querySelectorAll<HTMLElement>(
    `.product-options-form__forme`
  );
  $formeSwatches.forEach(($swatch) => {
    const swatchForme = $swatch.dataset.forme;
    if (swatchForme === forme) {
      $swatch.classList.add("active");
      // if active forme is sold out, add class tw-hidden to the atc button
      if ($swatch.classList.contains("not-available")) {
        $btn?.classList.add("tw-hidden");
        document
          .querySelector<HTMLElement>(".product-form__atc-button-soldout")
          ?.classList.remove("tw-hidden");
      } else {
        $btn?.classList.remove("tw-hidden");
        document
          .querySelector<HTMLElement>(".product-form__atc-button-soldout")
          ?.classList.add("tw-hidden");
      }
    }
  });
};

export default updateForme;
